module.exports = __webpack_public_path__ + "img/jili.f93c393c.png";